// extracted by mini-css-extract-plugin
export var deliveryRow = "_qk-a";
export var fixedHeight = "_qk-4";
export var freightLogo = "_qk-9";
export var fullWidth = "_qk-3";
export var priceColumn = "_qk-5";
export var radioSelected = "_qk-7";
export var radioUnselected = "_qk-6";
export var selectedOption = "_qk-2";
export var selectedOptionContainer = "_qk-1";
export var selection = "_qk-0";
export var tallSkeletonText = "_qk-8";